import type EventEmitter from 'eventemitter3';
import type * as awarenessProtocol from 'y-protocols/awareness';

export enum AwarenessChannel {
  TransientTransaction = 1 << 1,
  Telepointer = 1 << 2,
  Selection = 1 << 3,
  SmartLinks = 1 << 4,
  Participants = 1 << 5,
  Camera = 1 << 6,
  Typing = 1 << 7,
  Racing = 1 << 8,
  Slides = 1 << 9,
}

/**
 * Changeset of client IDs for a given awareness channel.
 */
export interface AwarenessClientIDs {
  /**
   * Client IDs that were added to the channel.
   */
  added: number[];
  /**
   * Client IDs that were updated in the channel.
   */
  updated: number[];
  /**
   * Client IDs that were removed from the channel.
   */
  removed: number[];
}

/**
 * Events emitted by the awareness container.
 */
export interface AwarenessContainerEvents {
  /**
   * Emitted when the awareness channel is updated.
   */
  update: (
    channel: AwarenessChannel,
    clientIDs: AwarenessClientIDs,
    origin: unknown,
  ) => void;
}

/**
 * Awareness container for a canvas.
 */
export interface CanvasAwareness {
  /**
   * Emits an event on the awareness container. Shared across all awareness
   * channels to enable batching of awareness updates.
   */
  emitter: EventEmitter<AwarenessContainerEvents>['emit'];

  /**
   * Gets the awareness stream for a given channel.
   */
  getAwareness(channel: AwarenessChannel): awarenessProtocol.Awareness;

  /**
   * Register a listener to be called when the awareness container is destroyed
   */
  onDestroy: (listener: VoidFunction) => void;
}
